import { VisitId } from '@dreryk/egabinet-visit-published-language-api';

import { visitPaths } from '~libs.desktop.shared.paths';

export const getPrescriptionVisitPath = (visitId: VisitId): string =>
   visitPaths.getVisitEntryPath(visitId.asNumber(), 'prescription');
